import Vue from 'vue/dist/vue.esm.js';

Vue.component('health-portal-videos', {
    template: '#health-portal-videos',
    delimiters: ['[[', ']]'],
    props: {
        categoriesJson: {},
    },
    data () {
        return {
            searchQuery: '',
            selectedCategories: [0],
            selectedCategory: 0,
            categories: JSON.parse(this.categoriesJson),
            videos: [],
            more: false,
            isLoading: false,
            loadingMore: false,
            nextPage: 1,
        }
    },
    mounted() {
        this.fetchVideos();
    },
    computed: {
        filteredVideos() {
            return this.videos && this.videos.length > 0 && this.videos.filter(item => {
                const matchesSearch =
                    item.title.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
                    (item.description && item.description.toLowerCase().includes(this.searchQuery.toLowerCase()));

                const matchesCategory =
                    this.selectedCategories.includes(0) ||
                    item.categories.some(category => this.selectedCategories.includes(category.id));

                return matchesSearch && matchesCategory
            })
        },
    },
    methods: {
        handleInput() {
            this.more = false;
            if(this.searchQuery.length > 3) {
                this.videos = [];
                this.nextPage = 1;
                this.fetchVideos(1);
            } else if (this.searchQuery.length < 3){
                this.fetchVideos(1);
            }
        },
        fetchVideos(pageNumber = 1) {
            this.more = false;
            this.isLoading = true;

            let _self = this;
            const categories = this.selectedCategories.includes(0)
                ? [0]
                : this.selectedCategories;

            const url = "/ajax/ajax-health-portal-videos?" + $.param({
                categoryIds: categories,
                page: pageNumber,
                searchQuery: this.searchQuery,
            });

            $.ajax({
                url: url,
                method: 'GET',
                success: (response) => {
                    if (response.results) {
                        const newVideos = response.results;
                        this.videos = pageNumber === 1
                            ? newVideos
                            : [...this.videos, ...newVideos];

                        _self.more = response.more;
                        _self.nextPage = response.nextPage;
                    }
                    setTimeout(() => {
                        _self.isLoading = false;
                        _self.loadingMore = false;
                        _self.selectedCategory = 0;
                    }, 350)
                },
                error: (error) => {
                    setTimeout(() => {
                        _self.isLoading = false;
                        _self.loadingMore = false;
                        _self.selectedCategory = 0;
                    }, 350)
                    console.error(error);
                }
            });
        },
        handleSelect(categoryId) {
            this.selectedCategory = categoryId;
            if (categoryId === 0) {
                this.selectedCategories = [0];
            } else {
                const index = this.selectedCategories.indexOf(categoryId);
                if (index === -1) {
                    this.selectedCategories = this.selectedCategories.filter(id => id !== 0);
                    this.selectedCategories.push(categoryId);
                } else {
                    this.selectedCategories.splice(index, 1);
                    if (this.selectedCategories.length === 0) {
                        this.selectedCategories = [0];
                    }
                }
            }
            this.fetchVideos(1);
        },
        isSelected(categoryId) {
            return this.selectedCategories.includes(categoryId);
        },
        loadMore() {
            if (this.more) {
                this.loadingMore = true;
                this.fetchVideos(this.nextPage);
            }
        }
    }
});
